import {SimpleTitle} from "../styles";
import React, {FC, useMemo} from "react";

export const NotificationSimple: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const [ giftData ] = actions;
    const { title } = giftData;

    const ParseTitle = useMemo(() => ( <div dangerouslySetInnerHTML={{__html: title}}/>) , [title])

    return <SimpleTitle>
        {ParseTitle}
    </SimpleTitle>
}import {SimpleTitle} from "../styles";
import React, {FC, useMemo} from "react";

export const NotificationSimple: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const [ giftData ] = actions;
    const { title } = giftData;

    const ParseTitle = useMemo(() => ( <div dangerouslySetInnerHTML={{__html: title}}/>) , [title])

    return <SimpleTitle>
        {ParseTitle}
    </SimpleTitle>
}